import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {ConsumerService} from '../../../../recursos/servicio/consumer.service';
import {AuthService} from '../../../../../autenticacion/servicios/auth.service';
import {StockProducts} from '../recursos/modelo/stockProducts';
import {MeasurementUnits} from 'app/layout/content/seguridad/emisor/recursos/modelo/MeasurementUnits';
import {UtilConfig} from '../../../../../autenticacion/servicios/UtilConfig';
import {WebServices} from '../../../../recursos/modelo/consumerModel/web-services.enum';

declare var $: any;
declare var swal: any;

@Component({
    selector: 'app-nuevo-producto',
    templateUrl: './view/nuevo-producto.component.html',
    styleUrls: ['./css/nuevo-producto.component.scss'],
    providers: [AuthService, ConsumerService]
})
export class NuevoProductoComponent implements OnInit {

    @Output() nuevoProducto = new EventEmitter<StockProducts>();
    @Output() cerrarPopup = new EventEmitter<boolean>();
    @Input() saveProducto = false;
    /**
     * PARAMETROS DE CARGA = LOADING
     *
     */
    loading_popup = false;
    /**
     * FORMULARIOS Y VALIDADORES
     *
     */
        // PRODUCTO NUEVO
    formProductoNuevo: FormGroup;
    vld_codigoProductoNuevo: FormControl;
    vld_descripcionProductoNuevo: FormControl;
    vld_valorProductoNuevo: FormControl;

    /**
     * VARIABLES DE DATA
     *
     */
    impuestos: any[] = [];
    @Input() productoNuevo: StockProducts = new StockProducts();
    measurementUnits: MeasurementUnits[];
    popup_text = '';

    constructor(private util: UtilConfig,
                private fb: FormBuilder,
                private router: Router,
                private consumerService: ConsumerService) {
        this.createFormControls();
        this.createFormProductoNuevo();
        this.impuestos = [];
        this.impuestos.push('GRAVADO');
        this.impuestos.push('INAFECTO');
        this.impuestos.push('EXONERADO');
    }


    ngOnInit(): void {
        this.getUnit();
    }


    createFormControls() {
        this.vld_codigoProductoNuevo = new FormControl({value: ''}, [Validators.required]);
        this.vld_descripcionProductoNuevo = new FormControl({value: ''}, [Validators.required]);
        this.vld_valorProductoNuevo = new FormControl({value: ''}, [Validators.nullValidator]);
    }

    createFormProductoNuevo() {
        this.formProductoNuevo = this.fb.group({
            'codigo': this.vld_codigoProductoNuevo,
            'descripcion': this.vld_descripcionProductoNuevo,
            'valor': this.vld_valorProductoNuevo
        });
    }


    onSubmitProducto() {
        if (this.formProductoNuevo.valid) {
            this.agregarProducto();
        } else {
            swal(
                'Campos obligatorios',
                'Debe completar todo los campos con (*)',
                'error'
            );
        }
    }


    agregarProducto() {
        if (!this.saveProducto) {
            this.nuevoProducto.emit(this.productoNuevo);
            return false;
        }
        const body = {
            product: this.productoNuevo
        };
        this.popup_text = 'Producto';
        this.loading_popup = true;
        this.consumerService.create(WebServices.URL_ACTUALIZAR_ITEMS, body)
            .subscribe(result => {
                if (result['product'] != null) {
                    const item = result['product'];
                    this.productoNuevo.productCode = '';
                    this.productoNuevo.description = '';
                    this.productoNuevo.unitPrice = 0;
                    this.nuevoProducto.emit(item);
                }
                this.loading_popup = false;
            }, err => {
                this.loading_popup = false;
                this.util.abrirModalErrorParaServicios(err, 'No se pudo crear el receptor', this.router);
            });
    }

    getUnit() {
        this.consumerService.update(WebServices.URL_GET_UNITS).subscribe(result => {
            this.measurementUnits = [];
            $.each(result['units'], (pos, item) => {
                if (pos < 20) {
                    this.measurementUnits.push(item);
                }
            });

        }, err => {
            swal({
                title: 'Error',
                text: err,
                type: 'error',
                showCancelButton: false,
                confirmButtonText: 'Proceder!'
            });

        });
    }

    cerrarPopupProducto() {
        this.cerrarPopup.emit(true);
    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/emisor/cmp-nuevo-producto/nuevo-producto.component.ts